var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3481 17.8058C10.9867 18.1441 10.5037 18.3333 10.0009 18.3333C9.49817 18.3333 9.01517 18.1441 8.65375 17.8058C5.34418 14.6883 0.908967 11.2057 3.07189 6.14968C4.24136 3.41593 7.04862 1.66663 10.0009 1.66663C12.9532 1.66663 15.7605 3.41593 16.93 6.14968C19.0902 11.1994 14.6658 14.699 11.3481 17.8058Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9168 9.16667C12.9168 10.7775 11.611 12.0833 10.0002 12.0833C8.38933 12.0833 7.0835 10.7775 7.0835 9.16667C7.0835 7.55583 8.38933 6.25 10.0002 6.25C11.611 6.25 12.9168 7.55583 12.9168 9.16667Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.6b01bfa2762686ef62e8561056691b96.svg";
export { ForwardRef as ReactComponent };